import { ActionDisabledCondition, BulkUserAction, UserAction } from '@mediahaven/shared';
import { ApiFragment, ExportLocation, RecordType, RecordTypeStructure } from '@stylehaven/components';

/* Export original (download)
 * Available when:
 *  * User has export rights
 *  * Is published or archived (== is not concept)
 *  * Has downloadable exportlocations
 *  * It is NOT deleted
 *  * It is not a representation
 *
 * Disabled when:
 *  * No original representation
 *  * Selection without children
 */
export function GetExportUserAction(record: ApiFragment, downloadableLocations: ExportLocation[]): UserAction {
    const isConcept: boolean = record.isConcept();

    const hasExportRights: boolean = record.hasExportRights();

    const hasLocalExportLocations: boolean = downloadableLocations.length > 0;
    const isRepresentation: boolean = record.getRecordType() === RecordType.Representation;
    const hasOriginal: boolean = record.getRecordStructure() !== RecordTypeStructure.Data || !!record.hasOriginal();

    const isSelection: boolean = [
        RecordType.Selection,
        RecordType.GenericSelection,
        RecordType.PersonalSelection
    ].includes(record.getRecordType());
    const selectionHasNoChildren: boolean = record.getRelationFragmentIdsOfType('Contains').length === 0;
    const isSelectionWithoutChildren: boolean = isSelection && selectionHasNoChildren;

    const isDeleted: boolean = record.isDeleted();

    const availableConditions: boolean[] = [
        hasExportRights,
        !isConcept,
        hasLocalExportLocations,
        !isDeleted,
        !isRepresentation
    ];
    const disableConditions: ActionDisabledCondition[] = [
        { condition: !hasOriginal, tooltip: 'general.no-original' },
        { condition: isSelectionWithoutChildren, tooltip: 'selection.empty' }
    ];

    const exportAction: UserAction = new UserAction(availableConditions, disableConditions);
    return exportAction;
}

/* Bulk Export original */
export function GetBulkExportUserAction(
    records: readonly ApiFragment[],
    downloadableLocations: ExportLocation[]
): BulkUserAction {
    const availableConditions: boolean[] = [];
    const disableConditions: ActionDisabledCondition[] = [];

    return new BulkUserAction(
        records,
        availableConditions,
        disableConditions,
        GetExportUserAction,
        false,
        downloadableLocations
    );
}
